import {  get } from "@services/apiService.js";
export default {

  getFontAwesomes(data) {
    return get(`/v4/design-manager/v1/fontawesomes`, data)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getFontAwesomeCategories(data) {
    return get(`/v4/design-manager/v1/fontawesomes/categories`, data)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
}